import { Box } from '@mui/material';
import Grid from '@mui/material/Grid';
import dayjs from 'dayjs';
import React, { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { format } from 'react-string-format';
import { constants } from '../../constants';
import useMyMApi from '../../hooks/useMyMApi';
import useValidationRules from '../../hooks/useValidationRules';
import useWebContext from '../../hooks/useWebContext';
import { MyMButton } from '../../ui-elements/MyMButton';
import { MyMImage } from '../../ui-elements/MyMImage';
import { MyMLabel } from '../../ui-elements/MyMLabel';
import { MyMLink } from '../../ui-elements/MyMLink';
import { MyMProgress } from '../../ui-elements/MyMProgress';
import ValidatableDatePicker from '../../ui-parts/ValidatableDatePicker';
import ValidatableTextBox from "../../ui-parts/ValidatableTextBox";
import { ValidatableTreeCheckbox } from "../../ui-parts/ValidatableTreeCheckbox";

/**
 * NewsRegistrationGlobal Page Component
 */
const NewsRegistrationGlobal = (props) => {
  const { newsId, handleModalClose, callerRefresh } = props;
  const screenId = 'MyM504';
  const apiRequest = useMyMApi(screenId);
  const [isLoading, setIsLoading] = useState(true);
  const [isSearchHandleValid, setIsSearchHandleValid] = useState(true);
  const [isSaveHandleValid, setIsSaveHandleValid] = useState(true);
  const [isRegisterHandleValid, setIsRegisterHandleValid] = useState(true);
  const [newsInfo, setNewsInfo] = useState(null);
  const [productTypeList, setProductTypeList] = useState([]);
  // 2024.9.16 MyMine Version2.0対応 Modify Start
  const [businessAreaSalesList, setBusinessAreaSalesList] = useState([]);
  const [businessAreaServiceList, setBusinessAreaServiceList] = useState([]);
  const [businessAreaAhsList, setBusinessAreaAhsList] = useState([]);
  const [businessAreaTrainingList, setBusinessAreaTrainingList] = useState([]);
  const [productTypeChecked, setProductTypeChecked] = useState([]);
  const [businessAreaSalesChecked, setBusinessAreaSalesChecked] = useState([]);
  const [businessAreaServiceChecked, setBusinessAreaServiceChecked] = useState([]);
  const [businessAreaAhsChecked, setBusinessAreaAhsChecked] = useState([]);
  const [businessAreaTrainingChecked, setBusinessAreaTrainingChecked] = useState([]);
  // 2024.9.16 MyMine Version2.0対応 Modify End
  const validationRules = useValidationRules();
  const { formState, control, setValue, trigger, clearErrors, reset, getFieldState, setError } = useForm({
    mode: 'onSubmit',
  })
  const { controlSettings, messageList, screenSettings } = useWebContext(screenId);

  useEffect(() => {
    const callbackRequestNewsRegistrationGlobalLoad = (result) => {
      setNewsInfo({
        ...result.NewsInfo,
        // PublishDateにはシステム日付を設定
        ...(newsId ? {} : { PublishDate: new Date().toLocaleDateString() })
      });

      setProductTypeList([...result.ProductTypeList]);
      // 2024.9.16 MyMine Version2.0対応 Modify Start
      setBusinessAreaSalesList([...result.BusinessArea.SalesList]);
      setBusinessAreaServiceList([...result.BusinessArea.ServiceList]);
      setBusinessAreaAhsList([...result.BusinessArea.AhsList]);
      setBusinessAreaTrainingList([...result.BusinessArea.TrainingList]);
      setProductTypeChecked([...result.ProductTypeList.filter(item => result.NewsReferenceMetadataIdList.includes(item.Id)).map(item => String(item.Id))])
      setBusinessAreaSalesChecked([...result.BusinessArea.SalesList.filter(item => result.NewsReferenceMetadataIdList.includes(item.Id)).map(item => String(item.Id))])
      setBusinessAreaServiceChecked([...result.BusinessArea.ServiceList.filter(item => result.NewsReferenceMetadataIdList.includes(item.Id)).map(item => String(item.Id))])
      setBusinessAreaAhsChecked([...result.BusinessArea.AhsList.filter(item => result.NewsReferenceMetadataIdList.includes(item.Id)).map(item => String(item.Id))])
      setBusinessAreaTrainingChecked([...result.BusinessArea.TrainingList.filter(item => result.NewsReferenceMetadataIdList.includes(item.Id)).map(item => String(item.Id))])
      // 2024.9.16 MyMine Version2.0対応 Modify End

      // 編集モードで対象Newsのデータが存在しない場合にエラーにする
      if (newsId && Object.values(result.NewsInfo).every(value => value === null)) {
        handleModalClose();
        window.alert(messageList.MyM_MSG_I_0059);
      }
      setIsLoading(false);
    }

    // 2024.5.8 MyMine Version1.5対応 Modify Start
    const queryPara = `?newsType=${constants.NewsType.GlobalNews}${newsId && `&newsId=${newsId}`}`;
    apiRequest.requestJson(`api/news/registration-load${queryPara}`, 'GET', callbackRequestNewsRegistrationGlobalLoad)
    // 2024.5.8 MyMine Version1.5対応 Modify End
  }, []);

  // 指定されたサイトのデータを取得
  const getNewsSiteData = async () => {
    setIsRegisterHandleValid(true)
    setIsSaveHandleValid(true);

    // フォーム上のエラーをリセットして初期化
    clearErrors();
    // urlフィールドの検証
    const result = await trigger("url");
    setIsSearchHandleValid(result);
    if (result) {
      // 検証に通ったらAPIリクエストを実施する
      setIsLoading(true);
      const callbackSuccess = (result) => {
        setNewsInfo({ ...newsInfo, Title: result.Title });
        setValue("title", result.Title);
        setIsLoading(false);
      }
      const callbackFailed = (result) => {
        // エラーメッセージが設定されていた場合、urlの入力値が不正であるとしエラーメッセージを表示
        if (result.Message === messageList.MyM_MSG_E_0003) {
          setError('url', { message: messageList.MyM_MSG_E_0029 });
        }
        setIsSearchHandleValid(false);
        setIsLoading(false);
      }
      apiRequest.requestJson(`api/news/get-news-site-data?url=${newsInfo.Url}`, 'GET', callbackSuccess, callbackFailed)
    } else {
      onError();
    }
  };

  // リクエストボディーの設定
  const createRequestBody = () => {
    // 2024.9.16 MyMine Version2.0対応 Add Start
    const businessAreaChecked = [...businessAreaSalesChecked, ...businessAreaServiceChecked, ...businessAreaAhsChecked, ...businessAreaTrainingChecked]
    // 2024.9.16 MyMine Version2.0対応 Add End
    let requestBody = {
      ...newsInfo,
      ProductTypeList: productTypeChecked,
      BusinessAreaList: businessAreaChecked
    }
    if (newsId) requestBody['NewsId'] = newsId;
    return requestBody
  }

  // 検証不要なルールに引っかかっていないかをチェック
  const checkErrorMessage = (checkResult, fieldName) => {
    let reCheckResult = checkResult;
    if (!checkResult) {
      // 対象フィールドのエラーメッセージがバリデーション対象外のメッセージの場合エラーメッセージの出力を制御する
      if (getFieldState(fieldName).error.message === messageList.MyM_MSG_E_0004) {
        clearErrors(fieldName);
        reCheckResult = true;
      }
    }
    return reCheckResult;
  }

  const triggerCheckErrorMessage = async (fieldName) => {
    let checkResult = await trigger(fieldName);
    checkResult = checkErrorMessage(checkResult, fieldName)
    return checkResult;
  }

  // Save(非公開)処理
  const handleSave = async () => {
    setIsRegisterHandleValid(true);
    setIsSearchHandleValid(true);
    // フォーム上のエラーをリセットして初期化
    clearErrors();
    // titleフィールドの検証
    const titleCheckresult = await trigger("title")
    // publishDateフィールドの検証
    const publishDateCheckResult = await triggerCheckErrorMessage("publishDate");
    // urlフィールドの検証
    const urlCheckResult = await triggerCheckErrorMessage("url")
    // contentsフィールドの検証
    const contentsCheckResult = await triggerCheckErrorMessage("contents");
    const result = titleCheckresult && publishDateCheckResult && urlCheckResult && contentsCheckResult;
    setIsSaveHandleValid(result);
    if (result) {
      if (!window.confirm(messageList.MyM_MSG_I_0030)) return;
      // 検証に通ったらAPIリクエストを実施する
      setIsLoading(true);
      const callbackSuccess = () => {
        handleModalClose();
        window.alert(messageList.MyM_MSG_I_0066);
        setIsLoading(false);
        callerRefresh();
      }
      const callbackFailed = () => {
        setIsLoading(false);
      }

      const requestBody = createRequestBody();
      requestBody.IsPublish = false;
      apiRequest.requestJson(`api/news/save-global-news`, 'POST', callbackSuccess, callbackFailed, requestBody)
    } else {
      onError();
    }
  };

  // Register(公開)処理
  const handleRegister = async () => {
    setIsSaveHandleValid(true);
    setIsSearchHandleValid(true);
    // フォーム上のエラーをリセットして初期化
    clearErrors();
    // titleフィールドの検証
    const titleCheckresult = await trigger("title")
    // publishDateフィールドの検証
    const publishDateCheckResult = await trigger("publishDate");
    // urlフィールドの検証
    const urlCheckResult = await trigger("url")
    // contentsフィールドの検証
    const contentsCheckResult = await trigger("contents");

    const result = titleCheckresult && publishDateCheckResult && urlCheckResult && contentsCheckResult;
    setIsRegisterHandleValid(result);
    if (result) {

      if (!window.confirm(messageList.MyM_MSG_I_0031)) return;
      setIsLoading(true);
      const callbackSuccess = () => {
        handleModalClose();
        window.alert(messageList.MyM_MSG_I_0067);
        setIsLoading(false);
        callerRefresh();
      }
      const callbackFailed = () => {
        setIsLoading(false);
      }

      const requestBody = createRequestBody();
      requestBody.IsPublish = true;
      apiRequest.requestJson(`api/news/save-global-news`, 'POST', callbackSuccess, callbackFailed, requestBody)
    } else {
      onError();
    }
  };

  // フォームの状態を初期化
  const handleClear = () => {
    // フォーム上のエラーメッセージ入力値をリセットして初期化
    reset();
    setNewsInfo(
      {
        Title: "",
        Url: "",
        Contents: "",
        PublishDate: new Date().toLocaleDateString()
      }
    );
    setValue("url", "");
    setValue("title", "");
    setValue("contents", "");
    setValue("publishDate", "");
    setProductTypeChecked([]);
    // 2024.9.16 MyMine Version2.0対応 Modify Start
    setBusinessAreaSalesChecked([])
    setBusinessAreaServiceChecked([])
    setBusinessAreaAhsChecked([])
    setBusinessAreaTrainingChecked([])
    // 2024.9.16 MyMine Version2.0対応 Modify End
    setIsSaveHandleValid(true);
    setIsSearchHandleValid(true);
    setIsRegisterHandleValid(true);
  };

  const onError = () => {
    window.alert(messageList.MyM_MSG_E_0003);
  };

  // 2024.5.8 MyMine Version1.5対応 Add Start
  /** News削除処理 */
  const handleDelete = () => {

    if (!window.confirm(messageList.MyM_MSG_I_0081)) return;
    setIsLoading(true);
    const callbackSuccess = () => {
      handleModalClose();
      window.alert(messageList.MyM_MSG_I_0082);
      setIsLoading(false);
      callerRefresh();
    }
    const callbackFailed = () => {
      setIsLoading(false);
    }

    const body = { 'newsId': newsId };
    apiRequest.requestJson(`api/news/delete`, 'POST', callbackSuccess, callbackFailed, body)
  };
  // 2024.5.8 MyMine Version1.5対応 Add End

  if (
    newsInfo === null &&
    // 2024.9.16 MyMine Version2.0対応 Modify Start
    businessAreaSalesList.length === 0 &&
    businessAreaServiceList.length === 0 &&
    businessAreaAhsList.length === 0 &&
    businessAreaTrainingList.length === 0 &&
    // 2024.9.16 MyMine Version2.0対応 Modify End
    productTypeList.length === 0)
    return (
      <MyMProgress />
    )

  return (
    <Box>
      {isLoading && <MyMProgress />}
      <Grid container >
        <Grid item xs={8} >
          <MyMLabel>{controlSettings.LabelList.lblUrlTitle}</MyMLabel>
          <Grid container >
            <Grid item xs={10}  >
              <ValidatableTextBox
                control={control}
                name="url"
                defaultValue={newsInfo.Url ? newsInfo.Url : ""}
                formState={formState}
                maxLength={1000}
                rules={{
                  ...validationRules.required(),
                  ...validationRules.maxLength(1000),
                }}
                onBlur={
                  (e) => {
                    setNewsInfo({ ...newsInfo, Url: e.target.value })
                  }
                }
                onChange={
                  async () => {
                    !isSearchHandleValid && await trigger("url");
                    !isSaveHandleValid && await triggerCheckErrorMessage("url")
                    !isRegisterHandleValid && await trigger("url")
                  }
                }
              />

            </Grid>
            <Grid item xs={1}  >
              <MyMButton onClick={getNewsSiteData} sx={{ height: '40px', minWidth: 'auto' }}>
                <MyMImage screenId={screenId} filePath={controlSettings.ImageList.btnSearch} />
              </MyMButton>
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={3} >
          <MyMLabel>{controlSettings.LabelList.lblPublishDateTitle}</MyMLabel>
          <ValidatableDatePicker
            name="publishDate"
            onChange={
              async (newValue) => {
                setNewsInfo({ ...newsInfo, "PublishDate": newValue !== null ? newValue?.$d.toLocaleString() : null })
                !isSaveHandleValid && await triggerCheckErrorMessage("publishDate")
                !isRegisterHandleValid && await trigger("publishDate")
              }
            }
            width="230px"
            value={newsInfo.PublishDate ? dayjs(newsInfo.PublishDate) : newsInfo.PublishDate}
            control={control}
            formState={formState}
            rules={{
              // 2024.5.8 MyMine Version1.5対応 Modify Start
              ...validationRules.date("PublishDate", true),
              // 2024.5.8 MyMine Version1.5対応 Modify End
            }}
          />
        </Grid>
      </Grid>
      <Box sx={{ marginTop: "20px" }}>
        <MyMLabel>{controlSettings.LabelList.lblTitleTitle}</MyMLabel>
        <ValidatableTextBox
          control={control}
          name="title"
          defaultValue={newsInfo.Title ? newsInfo.Title : ""}
          formState={formState}
          maxLength={256}
          rules={{
            ...validationRules.required(),
            ...validationRules.maxLength(256),
          }}
          onBlur={
            (e) => {
              setNewsInfo({ ...newsInfo, Title: e.target.value })
            }
          }
          onChange={
            async () => {
              !isSaveHandleValid && await trigger("title")
              !isRegisterHandleValid && await trigger("title")
            }
          }
          width='100%'
        />
      </Box>
      <Box sx={{ marginTop: "20px", height: "150px" }}>
        <MyMLabel>{controlSettings.LabelList.lblContentsTitle}</MyMLabel>
        <ValidatableTextBox
          control={control}
          name="contents"
          defaultValue={newsInfo.Contents ? newsInfo.Contents : ""}
          formState={formState}
          maxLength={2000}
          rules={{
            ...validationRules.required(),
            ...validationRules.maxLength(2000),
          }}
          multiline={true}
          rows={5}
          onBlur={e => setNewsInfo({ ...newsInfo, Contents: e.target.value })}
          onChange={
            async () => {
              !isSaveHandleValid && await triggerCheckErrorMessage("contents")
              !isRegisterHandleValid && await trigger("contents")
            }
          }
          width='100%'
        />
      </Box>
      <Box sx={{ marginTop: "30px" }}>
        <MyMLabel>{format(controlSettings.LabelList.lblComments, <MyMLink component='a' href={`mailto:${screenSettings.SupportEmailTo}`}>{controlSettings.LabelList.lnkContactSupport}</MyMLink>)}</MyMLabel>
      </Box>
      <MyMLabel sx={{ paddingTop: "5px" }}>{controlSettings.LabelList.lblMetaDataTitle}</MyMLabel>
      {/*2024.9.16 MyMine Version2.0対応 Modify Start*/}
      <Grid container spacing={2}>
        <Grid item xs={4} >
          <Box >
            <MyMLabel>{controlSettings.LabelList.lblProductTypeTitle}</MyMLabel>
            <ValidatableTreeCheckbox
              controllerName="checkboxList_productType"
              needsCascade={true}
              treeItemList={productTypeList}
              checkedList={productTypeChecked}
              setChecked={setProductTypeChecked}
              control={control}
              formState={formState}
              clearText={controlSettings.LabelList.btnProductTypeClearAll}
              trigger={trigger}
              height='355px'
              handleValid={isRegisterHandleValid}
            />
          </Box>
        </Grid>
        <Grid item xs={4} >
          <Box >
            <MyMLabel>{controlSettings.LabelList.lblBusinessAreaSalesTitle}</MyMLabel>
            <ValidatableTreeCheckbox
              controllerName="checkboxList_businessArea_sales"
              needsCascade={true}
              // 2024.9.16 MyMine Version2.0対応 Modify Start
              treeItemList={businessAreaSalesList}
              checkedList={businessAreaSalesChecked}
              setChecked={setBusinessAreaSalesChecked}
              // 2024.9.16 MyMine Version2.0対応 Modify End
              control={control}
              formState={formState}
              clearText={controlSettings.LabelList.btnBusinessAreaSalesClearAll}
              trigger={trigger}
              height='355px'
              handleValid={isRegisterHandleValid}
            />
          </Box>
        </Grid>
        <Grid item xs={4} >
          <Box >
            <MyMLabel>{controlSettings.LabelList.lblBusinessAreaServicePartsTitle}</MyMLabel>
            <ValidatableTreeCheckbox
              controllerName="checkboxList_businessArea_service"
              needsCascade={true}
              treeItemList={businessAreaServiceList}
              checkedList={businessAreaServiceChecked}
              setChecked={setBusinessAreaServiceChecked}
              control={control}
              formState={formState}
              clearText={controlSettings.LabelList.btnBusinessAreaServicePartsClearAll}
              trigger={trigger}
              height='355px'
              handleValid={isRegisterHandleValid}
            />
          </Box>
        </Grid>
        <Grid item xs={4} >
          <Box >
            <MyMLabel>{controlSettings.LabelList.lblBusinessAreaAhsTitle}</MyMLabel>
            <ValidatableTreeCheckbox
              controllerName="checkboxList_businessArea_ahs"
              needsCascade={true}
              treeItemList={businessAreaAhsList}
              checkedList={businessAreaAhsChecked}
              setChecked={setBusinessAreaAhsChecked}
              control={control}
              formState={formState}
              clearText={controlSettings.LabelList.btnBusinessAreaAhsClearAll}
              trigger={trigger}
              height='355px'
              handleValid={isRegisterHandleValid}
            />
          </Box>
        </Grid>
        <Grid item xs={4} >
          <Box >
            <MyMLabel>{controlSettings.LabelList.lblBusinessAreaTrainingTitle}</MyMLabel>
            <ValidatableTreeCheckbox
              controllerName="checkboxList_businessArea_training"
              needsCascade={true}
              treeItemList={businessAreaTrainingList}
              checkedList={businessAreaTrainingChecked}
              setChecked={setBusinessAreaTrainingChecked}
              control={control}
              formState={formState}
              clearText={controlSettings.LabelList.btnBusinessAreaTrainingClearAll}
              trigger={trigger}
              height='355px'
              handleValid={isRegisterHandleValid}
            />
          </Box>
        </Grid>
      </Grid>
      {/*2024.9.16 MyMine Version2.0対応 Modify End*/}
      <Grid container spacing={3} sx={{ marginTop: "1px" }}>
        {/* 2024.5.8 MyMine Version1.5対応 Modify Start */}
        <Grid item xs={newsId ? 2.4 : 3}  >
          <MyMButton onClick={handleClear} sx={{ width: '100%' }}>{controlSettings.LabelList.btnClear}</MyMButton>
        </Grid>
        {
          newsId &&
          <Grid item xs={2.4}  >
            <MyMButton onClick={handleDelete} sx={{ width: '100%' }}>{controlSettings.LabelList.btnDelete}</MyMButton>
          </Grid>
        }
        <Grid item xs={newsId ? 2.4 : 3}  >
          <MyMButton onClick={handleSave} sx={{ width: '100%' }}>{controlSettings.LabelList.btnSave}</MyMButton>
        </Grid>
        <Grid item xs={newsId ? 2.4 : 3}  >
          <MyMButton onClick={handleRegister} sx={{ width: '100%' }}>{controlSettings.LabelList.btnRegister}</MyMButton>
        </Grid>
        {/* 2024.5.8 MyMine Version1.5対応 Modify End */}
        <Grid item xs={newsId ? 2.4 : 3}  >
          <MyMButton onClick={handleModalClose} sx={{ width: '100%' }}>{controlSettings.LabelList.btnClose}</MyMButton>
        </Grid>
      </Grid>
    </Box>
  );
}

export default NewsRegistrationGlobal